import { render } from "./GlPermission.vue?vue&type=template&id=4f5e3be0&scoped=true"
import script from "./GlPermission.vue?vue&type=script&lang=js"
export * from "./GlPermission.vue?vue&type=script&lang=js"

import "./GlPermission.vue?vue&type=style&index=0&id=4f5e3be0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/duanju_admin_vue_live/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f5e3be0"]])

export default __exports__